import React from "react";
import { Button, Collapse, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface ConfigPanelShellProps {
    title: string;
    onClose: () => void;
    helpContent?: { title?: string; body: string };
    children: React.ReactNode;
    footer?: React.ReactNode;
}

export const ConfigPanelShell: React.FC<ConfigPanelShellProps> = ({
    title,
    onClose,
    helpContent,
    children,
    footer,
}) => {
    return (
        <div className="trigger-rule-config-panel d-flex flex-column h-100 overflow-y-auto">
            <div className="trigger-rule-config-panel-header d-flex align-items-center justify-content-between">
                <Text className="hs-fw-600 hs-fs-14 hs-color-BlackRussian">
                    {title}
                </Text>
                <Button
                    type="text"
                    onClick={onClose}
                    aria-label="Close"
                    icon={<CloseOutlined />}
                />
            </div>
            <div className="flex-fill py-3 px-3 d-flex flex-column">
                <div className="flex-grow-1 min-h-0">
                    {children}
                </div>
            </div>
            <div>
            {helpContent && (
                    <Collapse
                        ghost
                        className="trigger-rule-config-panel-help-collapse hs-border-top-light rounded-3 p-1"
                        size="small"
                        items={[
                            {
                                key: "how-it-works",
                                label: (
                                    <span className="hs-fw-600 hs-fs-12 hs-color-light-grey-2">
                                        {`What does this configuration do ?`}
                                    </span>
                                ),
                                children: <Text className="hs-fs-12 hs-color-light-grey-2 d-block">{helpContent.body}</Text>,
                            },
                        ]}
                    />
                )}
            </div>
            {footer}
        </div>
    );
};
